function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from "react";
import ReviewCard from "segments/desktop/core-components/review-card/review-card";
import { StyledReviews } from "./reviews.scss";
import DefaultProps from "./default-props";
class Reviews extends PureComponent {
    renderReviews() {
        const { cardFontSize, reviews, reviewCardOverrideHeight } = this.props;
        return reviews.map((review, index)=>{
            return /*#__PURE__*/ _jsx("div", {
                className: "review-card-component-wrapper",
                children: /*#__PURE__*/ _jsx(ReviewCard, _object_spread_props(_object_spread({}, review), {
                    fontSize: cardFontSize,
                    reviewCardOverrideHeight: reviewCardOverrideHeight
                }))
            }, index);
        });
    }
    render() {
        return /*#__PURE__*/ _jsx(StyledReviews, {
            className: "reviews",
            children: this.renderReviews()
        });
    }
    constructor(props){
        super(props);
    }
}
export { Reviews as default };
Reviews.defaultProps = DefaultProps;
